<div class="note-main">
  <p class="font-13">
    <strong>{{ 'attendance.note.internalNotes' | translate }}</strong>
  </p>

  <form [formGroup]="formGroup" (ngSubmit)="save()" class="input-wrapper">
    <input
      class="form-control pe-4"
      maxlength="500"
      formControlName="description"
      [placeholder]="'attendance.note.typePlaceholder' | translate"
    />

    <button type="submit" class="input-icon-button">
      <i class="ri-add-line"></i>
    </button>
  </form>

  <div class="d-block w-100 my-3">
    @for(item of (notes$ | async)?.slice(-1); track item.updatedAt) {
      <div class="d-flex align-items-center slide-in-from-top">
        <div class="flex-shrink-0 me-3">
          <div class="avatar-sm">
            <span class="avatar-title bg-warning-lighten text-warning rounded">
              <i class="mdi mdi-file-document-edit font-24"></i>
            </span>
          </div>
        </div>
        <div class="flex-grow-1">
          <h5 class="mt-0 mb-1 note-content">{{ item.description }}</h5>
          <p class="mb-0 font-12">{{ item.updatedAt | timezoneDate: 'DD/MM/YYYY HH:mm': getTimezoneCompanyCurrentUser() }}</p>
        </div>
        <div class="dropdown float-end">
          <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="mdi mdi-dots-vertical"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-end">
            <a href="javascript:void(0);" class="dropdown-item" (click)="onDelete(item)">{{ 'attendance.note.remove' | translate }}</a>
            <a href="javascript:void(0);" class="dropdown-item" (click)="edit(item)">{{ 'attendance.note.edit' | translate }}</a>
          </div>
        </div>
      </div>
    }
    <button
      class="btn btn-sm rounded-pill btn-soft-dark w-100 d-flex align-items-center justify-content-center gap-1 mt-3"
      (click)="listNote()"
    >
      {{ 'attendance.note.viewNotes' | translate }}
    </button>
  </div>
</div>
